import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';
import { firebaseConfig } from './FirebaseConfig';

const fire = firebase.initializeApp(firebaseConfig);

export default fire;
